export function reducer(state, { type, value }) {
  return {
    ...state,
    [type]: value
  }
}
